/* @pareto-engineering/generator-front 1.1.1-alpha.2 */
import * as React from 'react';
import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

import { useOutsideClick } from "../../../../../../utils";
import { Popover } from "../../../../../../a";
const baseClassName = styleNames.base;
const componentClassName = 'actions-container';

/**
 * This is the component description.
 */
const ActionsContainer = ({
  id,
  className: userClassName,
  style,
  preferredPopoverOrder,
  children
  // ...otherProps
}) => {
  const parentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useOutsideClick(parentRef, () => setIsOpen(false));
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style,
    ref: parentRef
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setIsOpen(!isOpen)
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon x-ui-icons c-x"
  }, "!")), /*#__PURE__*/React.createElement(Popover, {
    isOpen: isOpen,
    parentRef: parentRef,
    preferredPrimaryOrder: preferredPopoverOrder
  }, children));
};
ActionsContainer.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The preferred order for the popover
   */
  preferredPopoverOrder: PropTypes.arrayOf(PropTypes.string),
  /**
   * The children of the actions container
   */
  children: PropTypes.node
};
ActionsContainer.defaultProps = {
  preferredPopoverOrder: ['right', 'bottom', 'left', 'top']
};
export default ActionsContainer;